export const customerList = "CUSTOMER_LIST";